import { render, staticRenderFns } from "./OurMultilineText.vue?vue&type=template&id=798df5a7&"
import script from "./OurMultilineText.vue?vue&type=script&lang=js&"
export * from "./OurMultilineText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports